import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import HTTPStatus from 'http-status';

import {
    fetchUsuariDonarDeAlta
} from '../../commons/consultesServidor';

import {
    crearNotificacioSuccess,
    crearNotificacioWarning
} from '../../commons/notificacio';

import {
    errorConsultaServidor
} from '../../actions/error';

import {
    usuariIntroduccioOmplirDades
} from '../../actions/usuari';

import {
    RETARD_MILISEGONS_APARICIO_SPINNER
} from '../../constants';

const missatgeExitAltaUsuari = 'Usuari donat d\'alta correctament';
const missatgeErrorAltaUsuari = 'Error donant d\'alta usuari';
const missatgeAdvertenciaAltaUsuari = {
    titol: missatgeExitAltaUsuari,
    descripcio: 'La informació que apareix no està actualitzada.'
};

class UsuariDetallDonarDeAlta extends Component {

    constructor(props) {
        super(props);
        this.state = { modalVisible: false, peticioEnCurs: false };
        this.mostrarModal = this.mostrarModal.bind(this);
        this.amagarModal = this.amagarModal.bind(this);
        this.onClickOk = this.onClickOk.bind(this);
    }

    onClickOk() {
        this.setState({...this.state, peticioEnCurs: true});

        const { idUsuari } = this.props;

        return fetchUsuariDonarDeAlta(idUsuari)
            .then(
                (resposta) => {
                    const { body, status} = resposta;

                    this.setState({modalVisible: false, peticioEnCurs: false});

                    if (status === HTTPStatus.PARTIAL_CONTENT) {
                        crearNotificacioWarning(
                            missatgeAdvertenciaAltaUsuari.titol,
                            missatgeAdvertenciaAltaUsuari.descripcio
                        );
                        return;
                    }

                    const { esActiu, estacions, dades } = body;
                    this.props.usuariIntroduccioOmplirDades(idUsuari, dades, estacions, esActiu);
                    crearNotificacioSuccess(missatgeExitAltaUsuari);
                },
                (errorServidor) => {
                    this.setState({modalVisible: true, peticioEnCurs: false});
                    this.props.errorConsultaServidor(errorServidor, missatgeErrorAltaUsuari);
                }
            );
    }

    mostrarModal() {
        this.setState({...this.state, modalVisible: true});
    }

    amagarModal() {
        this.setState({...this.state, modalVisible: false});
    }

    render() {

        const { modalVisible, peticioEnCurs } = this.state;
        const loadingBotoOK = peticioEnCurs ? {delay: RETARD_MILISEGONS_APARICIO_SPINNER} : false;

        return (
            <div>
                <Button type='primary' size='large' onClick={this.mostrarModal}>
                    {'Donar d\'alta'}
                </Button>
                <Modal
                    visible={modalVisible}
                    title={'Donar d\'alta'}
                    closable={false}
                    footer={[
                        <Button key='ok' type='primary' loading={loadingBotoOK} onClick={this.onClickOk}>OK</Button>,
                        <Button key='cancel' disabled={peticioEnCurs} onClick={this.amagarModal}>Cancel·lar</Button>,
                    ]}
                >
                    <p>{'Aquest usuari es donarà d\'alta però no les seves estacions associades.'}</p>
                    <p>{'Voleu continuar?'}</p>
                </Modal>
            </div>
        );
    }
}

UsuariDetallDonarDeAlta.propTypes = {
    idUsuari: PropTypes.number.isRequired,
    usuariIntroduccioOmplirDades: PropTypes.func,
    errorConsultaServidor: PropTypes.func
};

const mapDispatchToProps = {
    usuariIntroduccioOmplirDades,
    errorConsultaServidor
};

export default connect(null, mapDispatchToProps)(UsuariDetallDonarDeAlta);



// WEBPACK FOOTER //
// ./src/components/usuari/usuariDetallDonarDeAlta.js